import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

/**
 * Componente para proteção de rotas que verifica se o usuário está logado
 * e se é do tipo correto (psicologo ou paciente).
 */
const AreaProtegida = ({ children, userType }) => {
  const isAuthenticated = localStorage.getItem('isLoggedIn');
  const storedUserType = localStorage.getItem('userType');
  const navigate = useNavigate();
  
  useEffect(() => {
    // Verificar autenticação e tipo de usuário no carregamento
    if (!isAuthenticated) {
      console.log('Usuário não autenticado, redirecionando para /login');
    } else if (storedUserType !== userType) {
      console.log(`Tipo de usuário incorreto. Esperado: ${userType}, Atual: ${storedUserType}`);
    }
  }, [isAuthenticated, storedUserType, userType, navigate]);
  
  // Se não estiver autenticado ou o tipo não for o correto, redireciona para login
  if (!isAuthenticated || storedUserType !== userType) {
    return <Navigate to="/login" replace />;
  }
  
  // Se estiver autenticado e for do tipo correto, renderiza os componentes filhos
  return children;
};

export default AreaProtegida; 